export default {
  items: [
    {
      name: 'Invoices',
      url: '/invoices',
      icon: 'icon-layers'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-user'
    },
    {
      name: 'Claims',
      url: '/claims',
      icon: 'icon-present'
    },
    {
      name: 'Pair Requests',
      url: '/pairrequests',
      icon: 'icon-link'
    },
    {
      name: 'Upload/Import',
      url: '/invoiceupload',
      icon: 'icon-cloud-upload'
    },
    {
      name: 'Imports',
      url: '/invoiceimports',
      icon: 'icon-folder'
    },
    {
      name: 'Customer Accounts',
      url: '/customeraccounts',
      icon: 'icon-speedometer'
    },
    {
      name: 'Upload Customer Accounts',
      url: '/customeraccountupload',
      icon: 'icon-cloud-upload'
    },
    {
      name: 'Campaigns',
      url: '/campaigns',
      icon: 'icon-trophy'
    },
    {
      name: 'Create Campaign',
      url: '/createcampaign',
      icon: 'icon-game-controller'
    },
    {
      name: 'Mobile APP Stuff',
      url: '/mobileappstuff',
      icon: 'icon-screen-smartphone'
    },
    {
      name: 'Banners',
      url: '/banners',
      icon: 'icon-picture'
    },
    {
      name: 'Notifications',
      url: '/notifications',
      icon: 'icon-bell'
    },
    {
      name: 'Single Claim Report',
      url: '/userclaimreport',
      icon: 'icon-screen-tablet'
    },
    {
      name: 'Claim Reports',
      url: '/generateclaimreports',
      icon: 'icon-grid'
    },
    // 20-Oct-2018, Luis: Phase2, configuration for invoice list display in APP.
    {
      name: 'Configuration',
      url: '/configuration',
      icon: 'icon-settings'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js